import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { OverviewPage } from '@/features/overview/pages/overview-page'
export const Route = createFileRoute('/_auth/w/$workspaceSlug/')({
  validateSearch: z.object({
    dialog: z.literal('wedding-identity').optional().catch(undefined),
  }),
  component: OverviewRoute,
})
function OverviewRoute() {
  const { workspaceSlug } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <OverviewPage
      key={workspaceSlug}
      slug={workspaceSlug}
      weddingIdentityOpen={search.dialog === 'wedding-identity'}
      onWeddingIdentityOpenChange={(open) =>
        navigate({
          search: (current) => ({
            ...current,
            dialog: open ? 'wedding-identity' : undefined,
          }),
          replace: !open,
        })
      }
    />
  )
}
